// extracted by mini-css-extract-plugin
export default {"container":"AlertTemplate_container__3Seu8","alert":"AlertTemplate_alert__Qv-+o","success":"AlertTemplate_success__ItZbM"};